import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchConfig } from "../lib/api";

const ConfigContext = createContext(null);

const FALLBACK = {
  company_name: "5999Cargo Group Europe",
  // Phase 18.12 — primary office line (always-active during business hours).
  // tel: form is the unformatted international E.164 used for tel: hrefs.
  // phone_display is the human-readable variant shown in UI / footers.
  whatsapp: "31630352160",
  email: "info@5999cargo.nl",
  finance_email: "finance@5999cargo.nl",
  phone: "+31488235999",
  phone_display: "+31 (0) 488 23 5999",
  address: "Steenhouwerstraat 88, 3194 AG, Rotterdam, The Netherlands",
};

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(FALLBACK);

  useEffect(() => {
    fetchConfig()
      .then((data) => setConfig({ ...FALLBACK, ...data }))
      .catch(() => setConfig(FALLBACK));
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
  const ctx = useContext(ConfigContext);
  return ctx || FALLBACK;
};
